/*! Copyright (c) Safe As Milk. All rights reserved. */

(function() {
  'use strict';

  function update24hLabelVisibility(variantId) {
    const labels = document.querySelectorAll('.product-image-24h-label');

    labels.forEach(function(label) {
      const variantIds = label.getAttribute('data-variant-ids');
      if (!variantIds) return;

      const variantIdsArray = variantIds.split(',').map(function(id) {
        return id.trim();
      });

      const has24h = variantIdsArray.includes(String(variantId));

      if (has24h) {
        label.classList.add('is-visible');
      } else {
        label.classList.remove('is-visible');
      }
    });
  }

  function getCurrentVariantId() {
    // Tenta encontrar o input hidden com o ID da variante
    const hiddenInput = document.querySelector('input[name="id"][type="hidden"], input[name="id"]:not([type])');
    if (hiddenInput && hiddenInput.value) {
      return hiddenInput.value;
    }

    // Tenta encontrar o select com o ID da variante
    const selectInput = document.querySelector('select[name="id"]');
    if (selectInput && selectInput.value) {
      return selectInput.value;
    }

    // Tenta encontrar radio button selecionado
    const radioInput = document.querySelector('input[name="id"][type="radio"]:checked');
    if (radioInput && radioInput.value) {
      return radioInput.value;
    }

    return null;
  }

  function init() {
    // Atualiza visibilidade inicial
    const currentVariantId = getCurrentVariantId();
    if (currentVariantId) {
      update24hLabelVisibility(currentVariantId);
    }

    // Escuta mudanças de variante através do evento customizado (usando event delegation)
    document.addEventListener('on:variant:change', function(event) {
      if (event.detail && event.detail.variant && event.detail.variant.id) {
        update24hLabelVisibility(event.detail.variant.id);
      }
    }, true); // Usa capture phase para pegar eventos que não fazem bubble

    // Escuta mudanças nos elementos variant-selects
    const variantSelectors = document.querySelectorAll('variant-selects');
    variantSelectors.forEach(function(selector) {
      selector.addEventListener('on:variant:change', function(event) {
        if (event.detail && event.detail.variant && event.detail.variant.id) {
          update24hLabelVisibility(event.detail.variant.id);
        }
      });
    });

    // Escuta mudanças diretas nos inputs de variante
    const variantInputs = document.querySelectorAll('select[name^="option"], input[name^="option"]');
    variantInputs.forEach(function(input) {
      input.addEventListener('change', function() {
        setTimeout(function() {
          const variantId = getCurrentVariantId();
          if (variantId) {
            update24hLabelVisibility(variantId);
          }
        }, 150);
      });
    });

    // Observa mudanças no input hidden de variante
    const hiddenInput = document.querySelector('input[name="id"][type="hidden"], input[name="id"]:not([type])');
    if (hiddenInput) {
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
            const variantId = hiddenInput.value;
            if (variantId) {
              update24hLabelVisibility(variantId);
            }
          }
        });
      });

      observer.observe(hiddenInput, {
        attributes: true,
        attributeFilter: ['value']
      });

      // Também escuta mudanças diretas no valor
      hiddenInput.addEventListener('change', function() {
        const variantId = hiddenInput.value;
        if (variantId) {
          update24hLabelVisibility(variantId);
        }
      });
    }
  }

  // Inicializa quando o DOM estiver pronto
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Reinicializa quando uma seção é carregada/atualizada
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:select', init);
})();
